import type {TargetAndTransition} from 'framer-motion';

export enum CardRole {
  FRONT = 'front',
  BACK_LEFT = 'backLeft',
  BACK_RIGHT = 'backRight',
}

export const CARD_POSES: Record<CardRole, TargetAndTransition> = {
  [CardRole.FRONT]: {x: 0, y: 0, scale: 1.4, rotate: 0, zIndex: 2},
  [CardRole.BACK_LEFT]: {x: '-57.3%', y: '3.9%', scale: 1, rotate: -10, zIndex: 1},
  [CardRole.BACK_RIGHT]: {x: '57.3%', y: '3.9%', scale: 1, rotate: 10, zIndex: 1},
};

export const CYCLE_INTERVAL_MS = 2000;
export const TRANSITION_DURATION_S = 0.45;
